<template lang="html">
    <div>
        <refund-single-row v-for="refund in refunds" :refund="refund" :key="refund.id" class="mb-1"></refund-single-row>
    </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import refundSingleRow from './refundSingleRow'
export default {

    props: {
        refunds: {
            tipe: Array,
            default: function () {
                return []
            }
        }
    },
    computed: {
        ...mapGetters([
            'getRefundReasons',
            'getPercentageOrCurrency'
        ])
    },
    methods: {
        refundStatus: function (refund) {
            return refund.isProcessed? 'Refunded' : 'Pending'
        },
        refundColor: function (refund) {
            return refund.isProcessed? 'bg-color-3' : 'bg-color-5'
        },
        refundIsRequest: function (refund) {
            return refund.isRequest? 'Yes' : 'No'
        },
        refundReason: function (refund) {
            let reasonId = refund.refundReasonType
            if(reasonId == 0){
                return refund.reason
            } else {
                let foundReason = this.getRefundReasons.find(r => r.id == reasonId)
                return foundReason? foundReason.text : '-'
            }
        },
        refundValue: function (refund) {
            let valNr = refund.amount
            let valType = this.getPercentageOrCurrency.find(r => r.id == refund.amountType).label

            return valNr+valType
        },
        refundItemName: function (refundItem) {
            if(refundItem.bookingGenderPrice){
                return refundItem.bookingGenderPrice.audienceTypeDescription
            } else if(refundItem.bookingComponent){
                return refundItem.bookingComponent.componentName + ' - ' + refundItem.bookingComponent.componentPriceName
            }
        },
        refundItemQtd: function (refundItem) {
            return refundItem.quantity
        }
    },
    components:{
        refundSingleRow
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// refundRows.vue?6067979a